var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4.00010618 C0,2.89547804 0.90234375,2 1.99456145,2 L19.0054385,2 C20.1070044,2 21,2.89005841 21,4.00010618 L21,16.9998938 C21,18.104522 20.0976562,19 19.0054385,19 L1.99456145,19 C0.892995579,19 0,18.1099416 0,16.9998938 L0,4.00010618 Z M3,5 L3,16 L18,16 L18,5 L3,5 Z"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "10.5 10 18 5 18 8 10.5 13 3 8 3 5"
})))));
export default SvgEmail;